<template>
	<div class="index">
		<div class="index-con">
			<div class="news-tips">
				Have made the submission in other ways and need to register alone?
				<span class="pay-btn">new register</span>
				<i class="el-icon-close"></i>
			</div>
			<div class="nav-lists">
				<div class="nav-title">Registration information needs to be submitted
				</div>
				<div class="nav-lists-con">
					<div class="coll-lists">
						<div class="coll-list">
							<p>
								<b>Conference</b>
							</p>
							<p>
								<b>Title</b>
							</p>
							<p>
								<b>Action</b>
							</p>
						</div>
						<div class="coll-list">
							<p>
								con
							</p>
							<p>
								con
							</p>
							<p>
								con
							</p>
						</div>
					</div>
				</div>
			</div>
			<div class="nav-lists">
				<div class="nav-title">
					Registered information that has been submitted
				</div>
				<div class="nav-lists-con">
					<div class="coll-lists reg-lists">
						<div class="coll-list">
							<p>
								<b>Conference</b>
							</p>
							<p>
								<b>Total</b>
							</p>
							<p>
								<b>Paper ID</b>
							</p>
							<p>
								<b>Payment</b>
							</p>
							<p>
								<b>Final paper</b>
							</p>
						</div>
						<div class="coll-list">
							<p> dda </p>
							<p> aa </p>
							<p> aa </p>
							<p>
								<span class="pay-btn" @click="toReg">Bank transfer</span>
							</p>
							<p>
								<span class="pay-btn">Click Upload</span>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},

		methods: {
			toOther(con) {
				this.$router.push(con)
			},
			toReg() {
				this.$router.push("/reg")
			},
		}
	}
</script>

<style scoped>
	.news-tips {
		display: flex;
		align-items: center;
		justify-content: end;
		padding: 15px;
		margin-bottom: 20px;
		box-sizing: border-box;
		color: #8a6d3b;
		background-color: #fcf8e3;
		border: 1px solid #faebcc;
		position: relative;
		border-radius: 4px;
	}

	.news-tips span {
		margin: 0 20px;
		flex-shrink: 0;
	}

	.news-tips i {
		right: 10px;
		top: 10px;
		font-size: 18px;
		cursor: pointer;
		font-weight: 600;
		position: absolute;
	}

	.nav-icon {
		width: 17px;
		height: auto;
		margin-right: 5px;
	}

	.text-blue {
		color: #428bca;
	}

	.text-brown {
		color: chocolate;
	}

	.pay-btn {
		color: #fff;
		border-radius: 4px;
		background-color: #5bc0de;
		padding: 0 15px;
		cursor: pointer;
		/* width: 100px; */
		height: 30px;
		line-height: 30px;
		text-align: center;
		box-sizing: border-box;
		display: inline-block;
	}

	.nav-lists {
		margin-bottom: 20px;
		border: 1px solid #ddd;
		border-radius: 4px;
	}

	.coll-lists {
		border: 1px solid #ddd;
		border-bottom: 0;
		border-radius: 4px;
	}

	.coll-list {
		display: flex;
		border-bottom: 1px solid #ddd;
		align-items: center;
	}

	.coll-list:nth-of-type(2n),
	.coll-list:hover {
		background: #f9f9f9;
	}

	.coll-list p {
		flex: 1;
		box-sizing: border-box;
		border-right: 1px solid #ddd;
		height: 40px;
		display: flex;
		align-items: center;
		padding: 15px 0 15px 15px;
		box-sizing: border-box;
	}

	.coll-list p:nth-last-of-type(1) {
		border-right: 0;
	}

	.sub-lists .coll-list p:nth-of-type(1) {
		flex: 1.5;
	}

	.pay-lists .coll-list p:nth-of-type(1),
	.reg-lists .coll-list p:nth-of-type(2),
	.sub-lists .coll-list p:nth-of-type(2),
	.sub-lists .coll-list p:nth-of-type(3) {
		flex: 2;
	}

	.nav-title {
		color: #333;
		background-color: #eee;
		border-bottom: 1px solid transparent;
		border-color: #ddd;
		padding: 10px 15px;
		border-top-left-radius: 3px;
		display: flex;
		align-items: center;
		border-top-right-radius: 3px;
	}

	.nav-title i {
		margin-right: 5px;
	}

	.nav-lists-con {
		padding: 20px;
		box-sizing: border-box;
	}


	.index-con {
		width: 1200px;
		margin: 0 auto;
		padding-top: 40px;
	}

	@media screen and (max-width: 768px) {
		.news-tips {
			text-align: right;
		}

		.index-con {
			width: 100%;
		}

		.login-nav {
			display: block;
		}

		.nav-lists,
		.login-nav-list {
			width: calc(100% - 40px);
			margin: 20px;
		}

		.coll-list p {
			width: 33.3%;
			padding: 15px 0 15px 5px;
		}

		.reg-lists .coll-list p {
			width: 25%;
		}

		.sub-lists .coll-list p:nth-of-type(1),
		.pay-lists .coll-list p:nth-of-type(1),
		.reg-lists .coll-list p:nth-of-type(2),
		.sub-lists .coll-list p:nth-of-type(2),
		.sub-lists .coll-list p:nth-of-type(3) {
			flex: 1;
		}

		.sub-lists .coll-list p:nth-last-of-type(1),
		.sub-lists .coll-list p:nth-last-of-type(2),
		.reg-lists .coll-list p:nth-last-of-type(2),
		.pay-lists .coll-list p:nth-last-of-type(1) {
			display: none;
		}

		.pay-btn {
			padding: 0 5px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/login/registration.vue